/**
 * 搜索标签
 */
export async function fetchTagByName(name: string): Promise<
  {
    name: string
    hot: number
  }[]
> {
  return http
    .get<
      {
        name: string
        hot: number
      }[]
    >('/v1/tag/search', {
      name
    })
    .then((res) => res.data || [])
    .catch(() => [])
}
